//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/DateBuilder.js";
import "../no/DateBuilder.js";
let d=[[[0,"AnimationCustomEndTime",1,0],[0,"AnimationCustomHeight",1,0],[0,"AnimationCustomStartTime",1,0],[0,"AnimationCustomWidth",1,0],[0,"AnimationFileOutput",1,0],[0,"AnimationFrameNumOfIterations",1,0],[1,"AnimationFrameTimeLimit",0,"DateBuilder",0],[0,"AnimationResolution",1,0],[0,"AnimationSolution",1,0],[0,"AutoCompletionCustomPixelRatio",1,0],[0,"AutoCompletionCustomQualityFactor",1,0],[0,"AutoCompletionType",1,0],[0,"Caustics",1,0],[0,"CustomFrameRate",1,0],[0,"Denoiser",1,0],[0,"FileInput",1,0],[0,"FolderInput",1,0],[0,"FrameRate",1,0],[0,"LockAspectRatio",1,1],[0,"ProcessingType",1,0],[0,"RemoteRender",1,0],[0,"RenderDuration",1,0],[0,"RenderQuality",1,0],[0,"ScheduledTaskName",1,0],[0,"ScheduledTaskPriority",1,0],[0,"TimeRange",1,0]],[],[]];
SPLM.Display.IrayPlusStudioAnimationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.IrayPlusStudioAnimationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationTimeRangeType = Object.freeze({
    "EntireTimeline" : "EntireTimeline", "UserDefined" : "UserDefined"});

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationRenderQualityType = Object.freeze({
    "Photoreal" : "Photoreal", "QualityInteractive" : "QualityInteractive", "FastInteractive" : "FastInteractive"});

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationRenderDurationType = Object.freeze({
    "IterationsperFrame" : "IterationsperFrame", "TimeperFrame" : "TimeperFrame", "AutoComplete" : "AutoComplete", "TimeLimitedAutoComplete" : "TimeLimitedAutoComplete"});

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationProcessingType = Object.freeze({
    "Interactive" : "Interactive", "Offline" : "Offline"});

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationAutoCompletionType = Object.freeze({
    "Complex" : "Complex", "Normal" : "Normal", "Simple" : "Simple", "None" : "None", "Custom" : "Custom"});

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationResolutionType = Object.freeze({
    "RenderWindow" : "RenderWindow", "UserDefined" : "UserDefined"});

SPLM.Display.IrayPlusStudioAnimationBuilder.AnimationFileOutputType = Object.freeze({
    "MicrosoftAVI" : "MicrosoftAVI", "SeriesofPNG" : "SeriesofPNG", "SeriesofJPG" : "SeriesofJPG", "SeriesofTIF" : "SeriesofTIF"});

SPLM.Display.IrayPlusStudioAnimationBuilder.FramesPerSecondRateType = Object.freeze({
    "Fps15" : "Fps15", "Fps24" : "Fps24", "Fps30" : "Fps30", "Fps60" : "Fps60", "Fps120" : "Fps120", "UserDefined" : "UserDefined"});

export default SPLM;